import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMentorshipProgramByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetMentorshipProgramByIdQuery = { __typename?: 'query_root', mentorshipProgram_by_pk?: { __typename?: 'mentorshipProgram', id: number, name: string, mentorLabel?: string | null, menteeLabel?: string | null, matchingMethod: string, createdAt?: any | null, createdByUserId?: string | null, workspaceLocationId?: number | null, workspaceId: number, workspaceLocation?: { __typename?: 'workspaceLocations', id: number, name: string, abbreviation?: string | null, city?: string | null, state?: string | null } | null, workspace?: { __typename?: 'workspaces', id: number, name: string } | null, mentorshipProgramModules: Array<{ __typename?: 'mentorshipProgramModule', id: number, name: string, order: number, content: string, duration?: number | null, createdAt: any, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, completed: boolean, reportedAsCompletedAt?: any | null, completedAt?: any | null, messageId?: any | null, startDate?: any | null, dueDate?: any | null, mentorship: { __typename?: 'mentorship', id: any, mentee?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentor?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null } }> }>, mentorshipSurveys: Array<{ __typename?: 'mentorshipSurvey', id: number, preSurveyEnabled: boolean, preSurveyLink?: string | null, preSurveyMentorRequired?: boolean | null, preSurveyMenteeRequired?: boolean | null, midSurveyEnabled: boolean, midSurveyLink?: string | null, midSurveyMentorRequired?: boolean | null, midSurveyMenteeRequired?: boolean | null, postSurveyEnabled: boolean, postSurveyLink?: string | null, postSurveyMentorRequired?: boolean | null, postSurveyMenteeRequired?: boolean | null, mentorshipSurveyProgress: Array<{ __typename?: 'mentorshipSurveyProgress', id: number, mentorshipSurveyId: number, completed: boolean, completedAt?: any | null, userId: string, mentorshipId: any, active?: boolean | null, surveyPrefix?: string | null, surveyLink?: string | null, user?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentorship?: { __typename?: 'mentorship', id: any, mentorId: string, menteeId: string } | null }> }>, mentorships: Array<{ __typename?: 'mentorship', id: any, createdAt?: any | null, mentorId: string, menteeId: string, mentor?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentee?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, mentorshipProgramModuleId: number, completed: boolean }> }>, userRelationshipRequests: Array<{ __typename?: 'userRelationshipRequests', id: any, selectedMentorshipProgramId?: number | null, requesterRole?: string | null, status: string, type?: string | null, requester: string, requestee: string, user: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null, menteeEnabled?: boolean | null, mentorEnabled?: boolean | null }, userByRequestee: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null, menteeEnabled?: boolean | null, mentorEnabled?: boolean | null } }> } | null };


export const GetMentorshipProgramByIdDocument = gql`
    query getMentorshipProgramById($id: Int!) {
  mentorshipProgram_by_pk(id: $id) {
    id
    name
    mentorLabel
    menteeLabel
    matchingMethod
    createdAt
    createdByUserId
    workspaceLocationId
    mentorLabel
    menteeLabel
    matchingMethod
    workspaceLocation {
      id
      name
      abbreviation
      city
      state
    }
    workspaceId
    workspace {
      id
      name
    }
    mentorshipProgramModules(order_by: {order: asc}) {
      id
      name
      order
      content
      duration
      createdAt
      mentorshipProgramProgresses {
        id
        completed
        reportedAsCompletedAt
        completedAt
        messageId
        startDate
        dueDate
        mentorship {
          id
          mentee {
            id
            fullName
            profilePhotoLink
          }
          mentor {
            id
            fullName
            profilePhotoLink
          }
        }
      }
    }
    mentorshipSurveys {
      id
      preSurveyEnabled
      preSurveyLink
      preSurveyMentorRequired
      preSurveyMenteeRequired
      midSurveyEnabled
      midSurveyLink
      midSurveyMentorRequired
      midSurveyMenteeRequired
      postSurveyEnabled
      postSurveyLink
      postSurveyMentorRequired
      postSurveyMenteeRequired
      mentorshipSurveyProgress {
        id
        mentorshipSurveyId
        completed
        completedAt
        userId
        user {
          id
          fullName
          profilePhotoLink
        }
        mentorshipId
        mentorship {
          id
          mentorId
          menteeId
        }
        active
        surveyPrefix
        surveyLink
      }
    }
    mentorships {
      id
      createdAt
      mentorId
      mentor {
        id
        fullName
        profilePhotoLink
      }
      menteeId
      mentee {
        id
        fullName
        profilePhotoLink
      }
      mentorshipProgramProgresses {
        id
        mentorshipProgramModuleId
        completed
      }
    }
    userRelationshipRequests(
      order_by: {createdAt: asc}
      where: {status: {_eq: "requested"}}
    ) {
      id
      selectedMentorshipProgramId
      requesterRole
      status
      type
      requester
      user {
        id
        fullName
        profilePhotoLink
        menteeEnabled
        mentorEnabled
      }
      requestee
      userByRequestee {
        id
        fullName
        profilePhotoLink
        menteeEnabled
        mentorEnabled
      }
    }
  }
}
    `;

/**
 * __useGetMentorshipProgramByIdQuery__
 *
 * To run a query within a React component, call `useGetMentorshipProgramByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipProgramByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipProgramByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMentorshipProgramByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMentorshipProgramByIdQuery, GetMentorshipProgramByIdQueryVariables> & ({ variables: GetMentorshipProgramByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorshipProgramByIdQuery, GetMentorshipProgramByIdQueryVariables>(GetMentorshipProgramByIdDocument, options);
      }
export function useGetMentorshipProgramByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorshipProgramByIdQuery, GetMentorshipProgramByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorshipProgramByIdQuery, GetMentorshipProgramByIdQueryVariables>(GetMentorshipProgramByIdDocument, options);
        }
export function useGetMentorshipProgramByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorshipProgramByIdQuery, GetMentorshipProgramByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorshipProgramByIdQuery, GetMentorshipProgramByIdQueryVariables>(GetMentorshipProgramByIdDocument, options);
        }
export type GetMentorshipProgramByIdQueryHookResult = ReturnType<typeof useGetMentorshipProgramByIdQuery>;
export type GetMentorshipProgramByIdLazyQueryHookResult = ReturnType<typeof useGetMentorshipProgramByIdLazyQuery>;
export type GetMentorshipProgramByIdSuspenseQueryHookResult = ReturnType<typeof useGetMentorshipProgramByIdSuspenseQuery>;
export type GetMentorshipProgramByIdQueryResult = Apollo.QueryResult<GetMentorshipProgramByIdQuery, GetMentorshipProgramByIdQueryVariables>;